module.exports = __webpack_public_path__ + "img/xls_icon.17701172.svg";